import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config.js";

const FreeServicePopup = ({ isOpen, onClose, onSubmit }) => {
  const [serviceData, setServiceData] = useState({
    serviceid: "",
    // tradesTotal: 1, // Commented: previously enforced 1 default credit
    tradesTotal: 0,
  });

  const [dropdownOptions, setDropdownOptions] = useState({
    serviceList: [],
  });

  // 🔹 Fetch services on open
  useEffect(() => {
    if (isOpen) {
      const token = localStorage.getItem("authToken");

      axios
        .get(`${API_URL}subscriber/get-dropdown-other`, {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ send token properly
          },
        })
        .then((res) => {
          if (res.data?.success && res.data?.data?.servicelist) {
            setDropdownOptions({
              serviceList: res.data.data.servicelist,
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching service list:", err);
        });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "tradesTotal") {
      // Limit to maximum 3 credits and minimum 1 (allow empty string while typing)
      if (value !== "" && (Number(value) > 3 || Number(value) < 1)) {
        return;
      }
    }
    setServiceData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // onSubmit({
    //   ...serviceData,
    //   tradesTotal: 1,
    // });
    onSubmit(serviceData);
    setServiceData({
      serviceid: "",
      // tradesTotal: 1,
      tradesTotal: 0,
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-11">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Add Free Service
              </h5>
            </div>
            <button type="button" className="btn btn-default" onClick={onClose}>
              &times;
            </button>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Service</label>
                    <select
                      name="serviceid"
                      value={serviceData.serviceid}
                      className="form-control"
                      onChange={handleChange}
                      required
                    >
                      <option value="">- Select -</option>
                      {dropdownOptions.serviceList.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.service_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Total Credits</label>
                    <input
                      type="number"
                      name="tradesTotal"
                      placeholder="Enter Total Credits"
                      className="form-control"
                      onChange={handleChange}
                      value={serviceData.tradesTotal}                     
                      // disabled
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12" style={{ textAlign: "right" }}>
                  <button
                    type="submit"
                    className="btn btn-primary submitBtn mx-2"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    name="cancel"
                    className="btn btn-default"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeServicePopup;
